import { createReducer, getUpdater } from '@advanza/advanza_generic'
import { changeEntity, changeFilter, invalidateFilters, receiveList } from './sharedReducerHandlers'

const update = getUpdater()

const handlers = {
    DEMANDUSERS_RECEIVE_LIST: receiveList,
    DEMANDUSERS_CHANGE_FILTER: changeFilter,
    CHANGE_ENTITY_DEMANDUSERS: changeEntity,
    INVALIDATE_DEMANDUSERS: invalidateFilters,
    DEMANDUSERS_REQUEST: (state) =>
        update(state, {
            isFetching: { $set: true },
        }),
}

const initialState = {
    isFetching: false,
    didInvalidate: false,
    counts: {},
    entities: {},
    result: {},
    filters: {},
}

export default createReducer(initialState, handlers)
